import React from 'react';

import { Frame, Head, HeadText, Title, Sub, Control } from './StatCard.styles';

export type StatCardProps = {
  title: string;
  sub?: string;
  /** Right-aligned header control (the time-range tabs / dropdown). */
  right?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
};

/** A metric card: the washed zinc surface, a title (+ optional subtitle) and an
 *  optional right-pinned control in the head, then the section body. */
export const StatCard = ({ title, sub, right, className, children }: StatCardProps): React.ReactElement => (
  <Frame className={className}>
    <Head>
      <HeadText>
        <Title text={title} tag="h3" />
        {sub ? <Sub text={sub} tag="span" /> : null}
      </HeadText>
      {right ? <Control>{right}</Control> : null}
    </Head>
    {children}
  </Frame>
);

export default StatCard;
